import { render, staticRenderFns } from "./columnsTab.vue?vue&type=template&id=41e1e00c&"
import script from "./columnsTab.vue?vue&type=script&lang=js&"
export * from "./columnsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports